var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{key:_vm.element.id,attrs:{"href":_vm.href,"no-":"","tileaction":"","color":"primary"}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('title')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }